export const formatNumberInput = value =>
  value &&
  value
    .toString()
    .replace(/(?!^)-/g, '')
    .replace(/[^-0-9.]/g, '')
    .replace(/(\..*)\./g, '$1');
